import { Event } from './event';

export class TransitionSucceededEvent extends Event<void> {}
